import { render, staticRenderFns } from "./IconTrendingUpSolid.vue?vue&type=template&id=6879eb62"
import script from "./IconTrendingUpSolid.vue?vue&type=script&lang=js"
export * from "./IconTrendingUpSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports